import useUploadAsDocument from 'modules/interaction/hooks/useUploadS3/useUploadAsDocument'
import { ActivityTransformer } from './ActivityTransformer.types'

const useDrawActivityTransformer = (): ActivityTransformer => {
  const { uploadFileAsDocument } = useUploadAsDocument()

  return async (value) => {
    const jsonString = typeof value === 'string' ? value : value.des
    const base64: string = JSON.parse(jsonString).base64
    const { document } = await uploadFileAsDocument({
      file: base64,
      fileType: 'base64'
    })

    return document.uuid
  }
}

export default useDrawActivityTransformer
